import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// Fetch all quotation requests
export const fetchQuotationRequests = createAsyncThunk(
  "quotationRequests/fetchAll",
  async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach((key) => {
        if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
          queryParams.append(key, params[key]);
        }
      });
      const url = `${BASE_URL}/quotations-requests${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to load data";
      throw new Error(message);
    }
  }
);

// Fetch single quotation request
export const fetchQuotationRequest = createAsyncThunk(
  "quotationRequests/fetchOne",
  async (id) => {
    try {
      const response = await axios.get(`${BASE_URL}/quotations-requests/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to load data";
      throw new Error(message);
    }
  }
);

// Add quotation request
export const addQuotationRequest = createAsyncThunk(
  "quotationRequests/add",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/quotations-requests`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
            Lang: i18n.language,
          },
        }
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to add data";
      return rejectWithValue({ message });
    }
  }
);

// Fetch transport types
export const fetchTransportTypes = createAsyncThunk(
  "quotationRequests/fetchTransportTypes",
  async () => {
    try {
      const response = await axios.get(`${BASE_URL}/transport-types`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data.data || [];
    } catch (error) {
      const message = error.response?.data?.message || "Failed to load transport types";
      throw new Error(message);
    }
  }
);

// Fetch clients
export const fetchClients = createAsyncThunk(
  "quotationRequests/fetchClients",
  async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach((key) => {
        if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
          queryParams.append(key, params[key]);
        }
      });
      const url = `${BASE_URL}/clients${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data.data?.data || [];
    } catch (error) {
      const message = error.response?.data?.message || "Failed to load clients";
      throw new Error(message);
    }
  }
);

// Fetch cities
export const fetchCities = createAsyncThunk(
  "quotationRequests/fetchCities",
  async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach((key) => {
        if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
          queryParams.append(key, params[key]);
        }
      });
      const url = `${BASE_URL}/cities${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data.data?.data || [];
    } catch (error) {
      const message = error.response?.data?.message || "Failed to load cities";
      throw new Error(message);
    }
  }
);

// Fetch winch partners
export const fetchWinchPartners = createAsyncThunk(
  "quotationRequests/fetchWinchPartners",
  async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach((key) => {
        if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
          queryParams.append(key, params[key]);
        }
      });
      const url = `${BASE_URL}/partners${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data.data?.data || [];
    } catch (error) {
      const message = error.response?.data?.message || "Failed to load winch partners";
      throw new Error(message);
    }
  }
);

// Fetch winch branches
export const fetchWinchBranches = createAsyncThunk(
  "quotationRequests/fetchWinchBranches",
  async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach((key) => {
        if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
          queryParams.append(key, params[key]);
        }
      });
      const url = `${BASE_URL}/winch-branches${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data.data?.data || [];
    } catch (error) {
      const message = error.response?.data?.message || "Failed to load winch branches";
      throw new Error(message);
    }
  }
);

// Fetch business sector users
export const fetchBusinessSectorUsers = createAsyncThunk(
  "quotationRequests/fetchBusinessSectorUsers",
  async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach((key) => {
        if (params[key] !== "" && params[key] !== null && params[key] !== undefined) {
          queryParams.append(key, params[key]);
        }
      });
      const url = `${BASE_URL}/business-sectors${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data.data?.data || [];
    } catch (error) {
      const message = error.response?.data?.message || "Failed to load business sector users";
      throw new Error(message);
    }
  }
);

const QuotationRequestsSlice = createSlice({
  name: "quotationRequests",
  initialState: {
    data: [],
    pagination: null,
    record: null,
    transportTypes: [],
    clients: [],
    businessSectorUsers: [],
    winchPartners: [],
    winchBranches: [],
    cities: [],
    quotationRequestsList: [], // For dropdown
    isLoading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all
      .addCase(fetchQuotationRequests.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchQuotationRequests.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data || [];
        state.pagination = action.payload.pagination || null;
      })
      .addCase(fetchQuotationRequests.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load data";
      })
      // Fetch one
      .addCase(fetchQuotationRequest.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchQuotationRequest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload;
      })
      .addCase(fetchQuotationRequest.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load data";
      })
      // Add
      .addCase(addQuotationRequest.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(addQuotationRequest.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message || i18n.language === "ar" ? "تم الإضافة بنجاح" : "Added successfully";
      })
      .addCase(addQuotationRequest.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || "Failed to add data";
      })
      // Fetch transport types
      .addCase(fetchTransportTypes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTransportTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.transportTypes = action.payload;
      })
      .addCase(fetchTransportTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load transport types";
      })
      // Fetch clients
      .addCase(fetchClients.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchClients.fulfilled, (state, action) => {
        state.isLoading = false;
        state.clients = action.payload;
      })
      .addCase(fetchClients.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load clients";
      })
      // Fetch cities
      .addCase(fetchCities.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchCities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.cities = action.payload;
      })
      .addCase(fetchCities.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load cities";
      })
      // Fetch winch partners
      .addCase(fetchWinchPartners.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchWinchPartners.fulfilled, (state, action) => {
        state.isLoading = false;
        state.winchPartners = action.payload || [];
      })
      .addCase(fetchWinchPartners.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load winch partners";
      })
      // Fetch winch branches
      .addCase(fetchWinchBranches.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchWinchBranches.fulfilled, (state, action) => {
        state.isLoading = false;
        state.winchBranches = action.payload || [];
      })
      .addCase(fetchWinchBranches.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load winch branches";
      })
      // Fetch business sector users
      .addCase(fetchBusinessSectorUsers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchBusinessSectorUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.businessSectorUsers = action.payload || [];
      })
      .addCase(fetchBusinessSectorUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to load business sector users";
      });
  },
});

export const { clearState } = QuotationRequestsSlice.actions;
export default QuotationRequestsSlice.reducer;

